const googleAds = {
  googleAds: 'Звіт про рекламу',
  showing: 'Показується',
  googleAdsOf: 'записи',
  noGoogleAdsFound: 'Записи не знайдено',
  addNewRecords: 'Додати нові записи',
  successfullyAdded: 'Усі записи успішно додано',
  delete: 'Видалити',
};
export default googleAds;
